// src/lib/a11y/high-contrast.ts
//
// High-contrast mode is a class on <html> plus a localStorage flag.
//
// It used to be re-applied from exactly one place: HighContrastToggle's mount
// effect, and that toggle is rendered only on /settings. So the preference
// survived client-side navigation but NOT a page load — a reload, a new tab, a
// new visit, or any hard navigation (starting a test is one) dropped a student
// who needs high contrast back to normal contrast until they went and opened
// Settings again.
//
// The fix is a tiny script in the root layout's <head> that re-applies the
// class before first paint on every page. Before paint, not in an effect, so
// the page never flashes low-contrast first.

/** The localStorage key. The toggle and the boot script must agree on it. */
export const HIGH_CONTRAST_KEY = 'high-contrast'

/** The class the stylesheet keys every high-contrast rule on. */
export const HIGH_CONTRAST_CLASS = 'high-contrast'

/**
 * Runs inline in <head>, before hydration. Kept dependency-free and wrapped in
 * try/catch: localStorage throws in some private modes and when storage is
 * blocked, and a throw here must never break the page.
 */
export const HIGH_CONTRAST_BOOT_SCRIPT = `(function(){try{if(localStorage.getItem(${JSON.stringify(
  HIGH_CONTRAST_KEY,
)})==='true'){document.documentElement.classList.add(${JSON.stringify(HIGH_CONTRAST_CLASS)})}}catch(e){}})();`
